<template>
  <ui-search-dropdown
    :filters="typeSections"
    :placeholder="typeSearchPlaceholder"
    section-checkbox
    @update:search="(value) => (filtersSearch = value)"
  >
    <template #default="{ open, toggleOpen }">
      <ui-filters-button
        aria-controls="toolbar-filter-dropdown-items"
        :set-toolbar-mode="ToolbarMode.Filters"
        :dropdown-open="open"
        :toggle-open="toggleOpen"
      />
    </template>
    <template #items>
      <ui-dropdown-items
        id="toolbar-filter-dropdown-items"
        :filters="typeSections"
        :dropdown-type="ToolbarMode.Filters"
        padding="px-4"
        :search="filtersSearch"
      />
    </template>
  </ui-search-dropdown>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { typeSearchPlaceholder, typeSections, ToolbarMode } from '@/features';

const filtersSearch = ref<string>('');
</script>
